import * as UI from "@iyk/ui"

import { appConfig } from "../app-config"

export const FanLayout = ({
  children,
  header,
  footer,
  hideBackground = false,
  hideBandImage = false
}: {
  children: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
  hideBackground?: boolean
  hideBandImage?: boolean
}) => {
  return (
    <div className="max-w-[var(--app-max-width)] w-full mx-auto">
      <div className="relative min-h-dvh text-foreground flex flex-col gap-2">
        {!hideBackground && (
          <div className="absolute inset-0 w-full overflow-hidden select-none h-[calc(100vh*2/3)]">
            <img
              src={appConfig.assets.images.background}
              alt="Profile Background"
              className={classForBackgroundImage({
                hidden: hideBandImage
              })}
            />
            <div className="absolute inset-0 size-full bottom-0 left-0 bg-[linear-gradient(to_top,_var(--gray-1),_rgba(0,0,0,0.7))]" />
          </div>
        )}
        {header}
        <main className="flex-1 size-full flex flex-col z-10">{children}</main>
        {footer}
      </div>
    </div>
  )
}

const classForBackgroundImage = UI.cva("size-full object-cover blur-md scale-110 opacity-100", {
  variants: {
    hidden: {
      true: "opacity-0 invisible"
    }
  }
})
